<template>
    <div class="animated fadeIn">
        <b-row class="py-2">
            <b-card header="Nueva Sede" class="w-100">
                <b-form @submit.prevent="store" enctype="multipart/form-data">
                    <h5 class="pb-1">Información General</h5>
                    <b-row>
                        <b-form-group
                            label="<strong>Nombre *</strong>"
                            label-for="name"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="name"
                                type="text"
                                placeholder="Nombre Sede"
                                v-model="item.name"
                                required></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Código *</strong>"
                            label-for="code"
                            :horizontal="false" class="col-md-4">
                            <headquarters-code-input id="code" v-model="item.code"></headquarters-code-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>CIF</strong>"
                            label-for="nif"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="nif"
                                type="text"
                                placeholder="GXXXXXXXX"
                                v-model="item.nif"></b-form-input>
                            <div v-if="item.nif && !validateCIF()">
                                <small class="form-text text-danger">
                                    No válido
                                </small>
                            </div>
                        </b-form-group>
                    </b-row>

                    <location-form
                        :input-size="'6'"
                        :communityRequired="true"
                        @community-change="community => {item.community = community}"
                        @province-change="province => {item.province = province}"
                        @town-change="town => {item.town = town}"
                        @postal-code-change="postalCode => {item.postalCode = postalCode}"
                        @address-change="address => {item.address = address}">
                    </location-form>

                    <b-row>
                        <b-form-group
                            label="<strong>Email</strong>"
                            label-for="email"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="email"
                                type="text"
                                placeholder="Correo electrónico"
                                v-model="item.email"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Teléfono 1</strong>"
                            label-for="phone1"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="phone1"
                                type="text"
                                placeholder="Fijo o móvil"
                                v-model="item.phone1"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Teléfono 2</strong>"
                            label-for="phone2"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="phone2"
                                type="text"
                                placeholder="Fijo o móvil"
                                v-model="item.phone2"></b-form-input>
                        </b-form-group>

                    </b-row>

                    <h5 class="pb-1 mt-4">Datos para Remesas</h5>
                    <b-row class="px-2">
                        <b-form-group
                            label="<strong>Ordenante *</strong>"
                            label-for="payer"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="payer"
                                type="text"
                                placeholder="Ordenante"
                                v-model="item.payer"
                                required></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>CIF Ordenante *</strong>"
                            label-for="payerNif"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="payerNif"
                                type="text"
                                placeholder="GXXXXXXXX"
                                v-model="item.payerNif"
                                required></b-form-input>

                            <div v-if="!validatePayerCIF()">
                                <small class="form-text text-danger">
                                    No válido
                                </small>
                            </div>
                        </b-form-group>
                    </b-row>
                    <b-row class="px-2">
                        <b-form-group
                            label="<strong>Cuenta Bancaria *</strong>"
                            label-for="bankAccount"
                            :horizontal="false" class="col-md-4">
                            <bank-account-selector id="bankAccount" v-model="item.bankAccount"></bank-account-selector>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Sufijo *</strong>"
                            label-for="suffix"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="suffix"
                                type="text"
                                placeholder="Sufijo"
                                v-model="item.suffix"
                                required></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>INE *</strong>"
                            label-for="ine"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="ine"
                                type="number"
                                placeholder="INE"
                                v-model="item.ine"
                                required></b-form-input>
                        </b-form-group>
                    </b-row>
                    <b-row class="px-2">
                        <b-form-group
                            label="<strong>Identificador de la Federación  *</strong>"
                            label-for="creditorIdentifier"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="creditorIdentifier"
                                type="text"
                                placeholder="Identificador"
                                v-model="item.creditorIdentifier"
                                required></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Fecha de Orden de Mandato *</strong>"
                            label-for="mandateSignDate"
                            :horizontal="false" class="col-md-4">
                            <v-date-picker
                                v-model="item.mandateSignDate"
                                class="p-0 date-picker-w-100 date-picker-custom-border"></v-date-picker>
                        </b-form-group>
                    </b-row>
                    <h5 class="pb-1 mt-4">Datos de certificado</h5>
                    <b-row>
                        <b-form-group
                            label="<strong>Presidente *</strong>"
                            label-for="president"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="president"
                                type="text"
                                placeholder="Nombre Presidente"
                                v-model="item.president"
                                required></b-form-input>
                        </b-form-group>

                        <b-form-group
                          label="<strong>Firma de Presidente</strong>"
                          label-for="signature"
                          :horizontal="false" class="col-md-4">
                          <b-form-file
                            v-model="item.signature"
                            name="signature"
                            placeholder="Seleccione un archivo..."></b-form-file>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Cargo *</strong>"
                            label-for="position"
                            :horizontal="false" class="col-md-4">
                            <multiselect
                                name="position"
                                v-model="item.position"
                                :options="genre.map(type => type.value)"
                                :multiple="false"
                                :custom-label="opt => genre.find(x => x.value == opt).label"
                                placeholder="Seleccione opción"
                                selectLabel="+"
                                deselectLabel="-"
                                required></multiselect>
                        </b-form-group>
                    </b-row>
                    <b-row>
                        <b-form-group
                            label="<strong>Encabezado</strong>"
                            label-for="header"
                            :horizontal="false" class="col-md-4">
                            <b-form-input
                                id="header"
                                type="text"
                                placeholder="Encabezado"
                                v-model="item.header"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Logo</strong>"
                            label-for="logo"
                            :horizontal="false" class="col-md-4">
                            <b-form-file
                                v-model="item.logo"
                                name="logo"
                                placeholder="Seleccione un archivo..."
                                button-label="Adjuntar"></b-form-file>
                        </b-form-group>
                    </b-row>

                    <b-row>
                      <b-form-group
                        label="<strong>Representante *</strong>"
                        label-for="representative"
                        :horizontal="false" class="col-md-4">
                        <b-form-input
                          id="representative"
                          type="text"
                          placeholder="Nombre Representante"
                          v-model="item.representative"
                          required></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="<strong>Firma de Representante</strong>"
                        label-for="representativeSignaturePath"
                        :horizontal="false" class="col-md-4">
                        <b-form-file
                          v-model="item.representativeSignaturePath"
                          name="representativeSignaturePath"
                          placeholder="Seleccione un archivo..."></b-form-file>
                      </b-form-group>
                    </b-row>

                    <label for="footer"><strong>Pie de página</strong></label>
                    <wysiwyg name="footer" v-model="item.footer"/>

                    <b-row class="py-4">
                        <b-col class="col-md-4 border-right">
                            <b-form-group
                                label="<h5>Departamentos</h5>"
                                label-for="departments"
                                :label-cols="3">
                                <b-form-checkbox-group
                                    stacked
                                    id="departments"
                                    name="departments"
                                    v-model="item.departments">
                                    <template v-for="deparment in departments">
                                        <b-form-checkbox :value="deparment.code">{{ deparment.name }}</b-form-checkbox>
                                    </template>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-md-4 border-right">
                            <b-form-group
                                label="<h5>Convenios</h5>"
                                label-for="agreements"
                                :label-cols="3">
                                <b-form-checkbox-group
                                    stacked
                                    id="agreements"
                                    name="agreements"
                                    v-model="item.agreements">
                                    <template v-for="agreement in agreements">
                                        <b-form-checkbox :value="agreement.code">{{ agreement.name }}</b-form-checkbox>
                                    </template>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="col float-left">
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!requirements()"
                                v-if="mixinCheckPermission('HEADQUARTERS_NEW')">
                                Guardar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import VueNotifications from 'vue-notifications';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import multiselect from 'vue-multiselect';
    import form from '@/helpers/form';
    import bankAccountSelector from '@/components/banks/BankAccountSelector';
    import locationForm from '@/components/location/LocationForm';
    import headquartersCodeInput from '@/components/headquarters/HeadquartersCodeInput';

    setupCalendar({
        firstDayOfWeek: 2 // Monday
    });

    export default {
        name: 'addHeadquarters',
        components: {
            'v-date-picker': DatePicker,
            multiselect,
            bankAccountSelector,
            locationForm,
            headquartersCodeInput
        },
        data: function () {
            return {
                topMenu: [
                    {
                        name: 'Volver',
                        path: '/admin/headquarters/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                item: {
                    uuid: 0,
                    code: null,
                    nif: null,
                    name: null,
                    address: null,
                    town: null,
                    postalCode: null,
                    province: null,
                    community: null,
                    phone1: null,
                    phone2: null,
                    fax: null,
                    payer: null,
                    payerNif: null,
                    president: null,
                    position: null,
                    bankAccount: null,
                    header: null,
                    footer: null,
                    signature: null,
                    logo: null,
                    departments: [],
                    agreements: [],
                    suffix: "",
                    ine: null,
                    creditorIdentifier: null,
                    mandateSignDate: null,
                    representative: null,
                    representativeSignaturePath: null
                },
                genre: [
                    {
                        value: "Presidente",
                        label: "Presidente"
                    },
                    {
                        value: "Presidenta",
                        label: "Presidenta"
                    },
                ],
                departments: [],
                agreements: []
            }
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topMenu);
            this.getGeneralCheck("departments", "departments", "uuid", "code");
            this.getGeneralCheck("agreements", "agreements", "uuid", "name");

        },
        methods: {
            store() {
                this.$_loadingMixin_showLoading();

                let parameters = Object.assign({}, this.item);
                parameters.bankAccountId = this.item.bankAccount.uuid;
                parameters.mandateSignDate = this.item.mandateSignDate.toISOString();

                axios.post('headquarters', form.objectToFormData(parameters))
                    .then((response) => {
                        if (response.status == "201") {
                            this.showSuccessMsg();
                            this.$_loadingMixin_hideLoading();
                            this.$router.push({path: '/admin/headquarters/list'});
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 400) {
                            this.showFormatMsg();
                        } else {
                            this.showErrorMsg();
                        }
                        this.$_loadingMixin_hideLoading();
                    });

            },
            async getGeneral(url, varName) {

                let self = this;
                let path = url;
                let list = new Array();

                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get(path);
                    this.$_loadingMixin_hideLoading();

                    if (response.status == "200") {
                        response.data.forEach(function (data) {
                            list.push(data);
                        });
                        this[varName] = response.data;
                        return list;
                    }
                } catch (error) {
                    console.log(error, "<-2");
                    self.showErrorMsg();
                    return error;
                }
            },
            async getGeneralCheck(url, varName, valName, textName) {

                let self = this;
                let path = url;
                let list = new Array();

                try {
                    this.$_loadingMixin_showLoading();
                    const response = await axios.get(path);
                    this.$_loadingMixin_hideLoading();

                    if (response.status == "200") {
                        response.data.forEach(function (data) {
                            data['name'] = data[textName];
                            data['code'] = data[valName];
                            list.push(data);
                        });
                        this[varName] = response.data;
                        return list;
                    }
                } catch (error) {
                    console.log(error, "<-2");
                    self.showErrorMsg();
                    return error
                }
            },
            validateCIF() {
                return form.validateCIF(this.item.nif);
            },
            validatePayerCIF() {
                return form.validateCIF(this.item.payerNif);
            },
            requirements() {
                this.item.suffix = "" + this.item.suffix;

                return !(
                    !this.item.code
                    || !this.item.name
                    || !this.item.community
                    || !this.item.payer
                    || !this.validatePayerCIF()
                    || !this.item.bankAccount
                    || !this.item.suffix
                    || !this.item.ine
                    || !this.item.creditorIdentifier
                    || !this.item.mandateSignDate
                    || !this.item.president
                    || !this.item.position
                );
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Registro almacenado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Operación denegada',
                message: 'Algo salió mal'
            },
            showFormatMsg: {
                type: VueNotifications.types.error,
                title: 'Operación rechazada',
                message: 'Por favor revise los campos'
            }
        }
    }
</script>
